import(/* webpackMode: "eager" */ "/app/node_modules/@akinon/next/utils/get-currency.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/account/contact-form.tsx");
